<script setup>
const features = [
  { svg: "WrInstall", title: "Easy<br />to Install" },
  { svg: "WrHeadless", title: "Headless<br />CMS" },
  { svg: "WrHMVC", title: "HMVC<br />Ready" },
  { svg: "WrControlPanel", title: "Extendable<br />Control Panel" },
  { svg: "WrVueApps", title: "Isolated<br />Vue Apps" },
  { svg: "WrTheme", title: "Theme with<br />no restrict" },
];
</script>

<template>
  <div class="pt-10 max-w-screen-xl mx-auto">
    <div class="mb-16">
      <div
        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-4 max-w-[900px] mx-auto text-[var(--secondary-foreground)]"
      >
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="flex flex-col items-center text-center"
        >
          <div class="bg-[image:var(--border-cms-card)] mb-4 rounded-xl p-px">
            <div
              class="bg-[image:var(--bg-cms-card)] p-3 md:p-6 rounded-xl size-20 md:size-24 flex items-center justify-center"
            >
              <WrSVGIcon :name="feature.svg" class="mx-auto" />
            </div>
          </div>
          <h3 v-html="feature.title" class="text-lg"></h3>
        </div>
      </div>
    </div>

    <div
      class="grid md:grid-cols-2 gap-7 text-[var(--secondary-foreground)] lg:px-16"
    >
      <div class="gradient-border-mask relative h-full">
        <div
          class="bg-[image:var(--bg-cms-card-large)] rounded-xl z-10 relative h-full p-5 pb-0 md:px-10 md:pt-12"
        >
          <span
            class="text-[var(--foreground)] dark:text-[var(--primary)] text-xs md:text-sm mb-2 block"
            >Headless CMS</span
          >
          <h2 class="text-xl md:text-2xl mb-4">
            Flexibility Redefined with Headless CMS
          </h2>

          <p class="mb-6">
            A headless CMS delivers content through APIs, empowering seamless
            integration with any platform or device. Break free from traditional
            limitations and build custom, future-ready experiences for web,
            mobile, and beyond.
          </p>

          <NuxtLink
            to="/services/cms-development"
            class="text-[var(--primary)] inline-flex items-center group relative z-10"
          >
            CMS Services

            <WrSVGIcon
              name="WrRight"
              class="size-4 ml-1 transform group-hover:translate-x-1 transition-transform"
            />
          </NuxtLink>

          <NuxtImg
            :src="
              $colorMode.preference == 'dark'
                ? '/images/headless-dark.webp'
                : '/images/headless.webp'
            "
            alt="headless"
            width="490"
            height="281"
            class="mx-auto -mt-4"
            loading="lazy"
            format="webp"
          />
        </div>
      </div>

      <div class="flex flex-col gap-7">
        <div class="gradient-border-mask relative h-full">
          <div
            class="bg-[image:var(--bg-cms-card-large)] h-full relative z-10 rounded-xl p-5 md:px-6"
          >
            <NuxtImg
              alt="omnichannel"
              :src="
                $colorMode.preference == 'dark'
                  ? '/images/omnichannel-dark.webp'
                  : '/images/Omnichannel.webp'
              "
              width="316"
              height="161"
              class="mx-auto"
              loading="lazy"
              format="webp"
            />
            <div class="">
              <p
                class="text-[var(--foreground)] dark:text-[var(--primary)] text-xs md:text-sm"
              >
                Deliver content seamlessly to any platform
              </p>
              <h2 class="text-xl md:text-2xl">Omnichannel Content Delivery</h2>
            </div>
          </div>
        </div>

        <div class="gradient-border-mask relative h-full">
          <div
            class="bg-[image:var(--bg-cms-card-large)] relative mx-auto z-10 h-full rounded-xl p-5 md:px-6"
          >
            <NuxtImg
              alt="omnichannel"
              :src="
                $colorMode.preference == 'dark'
                  ? '/images/delivery-dark.webp'
                  : '/images/delivery.webp'
              "
              width="316"
              height="127"
              class="mx-auto"
              loading="lazy"
              format="webp"
            />
            <div class="mt-4">
              <p
                class="text-[var(--foreground)] dark:text-[var(--primary)] text-xs md:text-sm"
              >
                Frontend-bckend decoupling flexibility
              </p>
              <h2 class="text-xl md:text-2xl">
                Enhanced Developer Flexibility
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
